<!--
 * @Description: 机构审核详情-开通服务面板组件
 * @Author: wanqian
 * @Date: 2022-03-28 16:58:14
-->
<template>
  <div class="body">
    <div class="openhservice-panel-main">
    	<el-form class="openingHsvcForm" ref="openingHsvcForm" :model="openingHsvcForm" :rules="rules" 
        label-position="top" label-width="200px">
				<div v-for="(openingHsvc, index) in openingHsvcForm.openingHsvcList" :key="index">
					<el-row style="margin: 10px 0 0 0; height: 40px" :gutter="20" type="flex" align="middle">
						<el-form-item label="">
							<el-checkbox v-model="openingHsvc.opened" disabled>
                {{openingHsvc.hsvcCategoryText}}
              </el-checkbox>
						</el-form-item>
						<el-form-item style="margin-left: 20px" label="" :prop="'openingHsvcList.' + index + '.timeRange'" 
              :rules="{required: true, message: '请选择服务时间', trigger: 'blur'}">
							<el-time-picker style="width: 260px" size="small" v-model="openingHsvc.timeRange" is-range 
                placeholder="选择时间范围" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" 
                :readonly="readonly" :clearable="false" format = 'HH:mm:ss' value-format = 'HH:mm:ss'>
							</el-time-picker>
						</el-form-item>
						<el-form-item label="">
							<el-checkbox style="margin-left: 25px" v-model="openingHsvc.isWholeDay" :disabled="readonly" 
								:true-label="1" :false-label="0">
                全天(24小时服务)
              </el-checkbox>
						</el-form-item>
					</el-row>
          <el-row style="margin: 30px 0" :gutter="0" type="flex" justify="space-between" align="middle">
            <el-form-item label="护理员等级价格：" prop="levelPrices">
              <div class="bk-level-prices">
                <div class="level-price-item">
                  <span>初级护理员：</span>
                  <el-input style="width: 130px" size="small" v-model="openingHsvc.primaryPriceYuan" 
                    placeholder="请输入" :readonly="readonly">
                    <template slot="append">元</template>
                  </el-input>
                </div>
                <div class="level-price-item">
                  <span>中级护理员：</span>
                  <el-input style="width: 130px" size="small" v-model="openingHsvc.middlePriceYuan" 
                    placeholder="请输入" :readonly="readonly">
                    <template slot="append">元</template>
                  </el-input>
                </div>
                <div class="level-price-item">
                  <span>高级护理员：</span>
                  <el-input style="width: 130px" size="small" v-model="openingHsvc.highPriceYuan" placeholder="请输入" 
                    :readonly="readonly">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </div>
            </el-form-item>
				  </el-row>
				</div>
			</el-form>
		</div>
    <div class="bk-wizard-bottons" style="padding-right: 25px;">
      <wizard-buttons :mode="modeReview" :status="btnStatus" @btnpressed="handleInstReviewBtnSelection" />
    </div>
  </div>
</template>

<script>
import instReviewStore from './InstReviewStore.js'

let InstOpenHservicePanel = {
  name: 'InstReviewOpenHservicePanel',
  instReviewStore,

  data() {
    return {
      btnStatus: {'prev': true, 'next': false, 'submit': true},
      rules: {},
      openingHsvcForm: {openingHsvcList: []},
    }
  },

  computed: {
    modeReview() {
      return instReviewStore.state.mode;
    },

    readonly() {
      return instReviewStore.state.mode == 'details';
    }
  },

  methods: {
    initData() {
      //后台返回时间数据只有时分秒，人为拼接上临时日期，用于timePicker显示交互，在提交是会去掉拼接的日期
      let arr = instReviewStore.state.openingHsvcList;
      let openingHsvcList = [];
      if (!arr) {
        this.$set(this.openingHsvcForm, 'openingHsvcList', []);
        return;
      }
      arr.forEach((element) => {
        if (element.startTime && element.endTime) {
          let startTime = "2016-09-10 " + element.startTime;
          let endTime = "2016-09-10 " + element.endTime;
          let startTimeDate = this.dateUtil.dateTimeFormat(startTime);
          let endTimeDate = this.dateUtil.dateTimeFormat(endTime);
          this.$set(element, 'timeRange', [startTimeDate, endTimeDate]);
        }
        openingHsvcList.push(element);
      });
      this.$set(this.openingHsvcForm, 'openingHsvcList', openingHsvcList);
    },

    handleInstReviewBtnSelection(operateReview) {
      if (this.modeReview == 'details' || operateReview != 'next' && operateReview != 'add' && operateReview != 'edit') {
        this.$emit("panel-operate", operateReview);
        return true;
      }
      this.$refs.openingHsvcForm.validate((valid) => {
        if (!valid) return false;
        else {
          this.$emit("panel-operate", operateReview);
          return true;
        }
      });
    },

    resetDataAndSync() {
      //将timeRange的值去掉前面加的日期（2016-09-10 ）再赋值给startTime和endTime，否则下次切换回来时段显示有问题
      this.openingHsvcForm.openingHsvcList.forEach(element => {
        if (element.timeRange && element.timeRange.length == 2) {
          element.startTime = element.timeRange[0].indexOf('2016-09-10 ') == -1 ? element.timeRange[0] 
            : element.timeRange[0].substr(11);
          element.endTime = element.timeRange[1].indexOf('2016-09-10 ') == -1 ? element.timeRange[1] 
            : element.timeRange[1].substr(11);
        }
      });
      //销毁的时候同步数据
      instReviewStore.commit('changeOpeningHsvcList', this.openingHsvcForm.openingHsvcList);
    },
  },

  mounted() {
    this.initData();
  },

  destroyed() {
    this.resetDataAndSync();
  },
}
export default InstOpenHservicePanel
</script>

<style scoped>
.openhservice-panel-main {
  margin: 20px 92px 200px 25px;
	padding-top: 30px;
	text-align: left;
}

.openingHsvcForm {
  margin-bottom: 60px;
}

.bk-level-prices {
	margin-top: 22px;
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	align-items: center;
}

.level-price-item {
	display: flex;
	flex-direction: row;
	align-items: center;
	margin: 0 30px 10px 0;
}
</style>
<style>
.openhservice-panel-main .el-form--label-top .el-form-item__label {
	padding: 0px;
  line-height: 26px;
}

.openhservice-panel-main .el-form-item__content {
  line-height: initial;
}
</style>


// WEBPACK FOOTER //
// src/components/review/components/InstReviewDetails/InstReviewOpenHservicePanel.vue